module.exports = __webpack_public_path__ + "static/media/program_step_2_en.2a7874d5.svg";